module.exports = __webpack_public_path__ + "img/slash_v1.3c6f88c5.svg";